import { render, staticRenderFns } from "./TopFormatBlocks.vue?vue&type=template&id=74198a26"
import script from "./TopFormatBlocks.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopFormatBlocks.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports